import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2c8cc785"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "confirm-delete__title" };
const _hoisted_2 = ["innerHTML"];
import ActionDialog from '@/components/campaigns/action/ActionDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfirmDeleteDialog',
    props: {
        modelValue: { type: Boolean },
        campaignName: {},
        loading: { type: Boolean }
    },
    emits: ["update:modelValue", "confirm", "cancel"],
    setup(__props, { emit }) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ActionDialog, {
                "model-value": _ctx.modelValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = val => emit('update:modelValue', val)),
                loading: _ctx.loading,
                tone: 'danger',
                "confirm-label": _ctx.$t('breadcrumb.email.campaigns.dialogs.delete.confirm'),
                "cancel-label": _ctx.$t('cancel'),
                onConfirm: _cache[1] || (_cache[1] = ($event) => (emit('confirm'))),
                onCancel: _cache[2] || (_cache[2] = ($event) => (emit('cancel')))
            }, {
                title: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('breadcrumb.email.campaigns.dialogs.delete.title')), 1)
                ]),
                description: _withCtx(() => [
                    _createElementVNode("span", {
                        innerHTML: _ctx.$t('breadcrumb.email.campaigns.dialogs.delete.description', { name: props.campaignName })
                    }, null, 8, _hoisted_2)
                ]),
                _: 1
            }, 8, ["model-value", "loading", "confirm-label", "cancel-label"]));
        };
    }
});
